<template>
  <div class="hello">
    <h3> {{question}}</h3>
    <hr/>
  </div>
</template>

<script>
export default {
  name: 'QuizQuestion',
  props: {
    question: String
  },
  data () {
      return {}
  },
  methods: {},
  created () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
